import {
  CardSelectorEditMode,
  CardSelectorEditModeProps,
} from './CardSelectorEditMode';
import {
  CardSelectorReadMode,
  CardSelectorReadModeProps,
} from './CardSelectorReadMode';
import { CardSelectorSkeleton } from './CardSelectorSkeleton';

type CardSelectorProps = (
  CardSelectorReadModeProps | CardSelectorEditModeProps
) & {
  isLoading?: boolean;
};

export const CardSelector = ({
  isLoading = false,
  ...props
}: CardSelectorProps) => {
  if (isLoading) {
    return <CardSelectorSkeleton />;
  }

  return 'selectedValue' in props ? (
    <CardSelectorReadMode {...props} />
  ) : (
    <CardSelectorEditMode {...props} />
  );
};

CardSelector.displayName = 'CardSelector';
